<template>
    <div class="containter" v-loading = 'loading'>
        <div class="topSelect">
            <div class="item">
                <label>审核状态：</label>
                <el-select v-model="status" @change="init(1)" style="width:150px" size="mini" clearable placeholder="结算单状态">
                    <el-option
                    v-for="(item,index) in statusList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <label>记账月份：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:140px;"
                    v-model="change_month"
                    :clearable='true'
                    type="month"
                    size="mini"
                    value-format="yyyy-MM"
                    placeholder="月份筛选">
                </el-date-picker>
            </div>
            <div class="item">
                <label>消耗月份：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:140px;"
                    v-model="screenMonth"
                    :clearable='true'
                    type="month"
                    size="mini"
                    value-format="yyyy-MM"
                    placeholder="月份筛选">
                </el-date-picker>
            </div>
            <div class="item" style="float:right">
                <div class="batchDelete" @click="init(1,'exportFlag')">导出</div>
            </div>
            <div class="item">
                <label>签约公司：</label>
                <el-input placeholder="请输入签约公司" style="width:200px" v-model.trim="company" clearable  @keydown.enter.native="company?init(1):''" @clear="init(1)" size="mini">
                    <el-button slot="append" icon="el-icon-search" @click="company?init(1):''" style="padding:0 10px"></el-button>
                </el-input>
            </div>
            <div class="item">
                <label>客户名称：</label>
                <el-input placeholder="请输入客户名称" style="width:200px" v-model.trim="customer_name" clearable  @keydown.enter.native="customer_name?init(1):''" @clear="init(1)" size="mini">
                    <el-button slot="append" icon="el-icon-search" @click="customer_name?init(1):''" style="padding:0 10px"></el-button>
                </el-input>
            </div>
            <div class="item">
                <label>财务审核时间：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:240px"
                    v-model="approved_date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    size='mini'
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
        </div>
        <div>
            <ux-grid
                ref="plxTable"
                :height="height"
                show-footer-overflow="tooltip"
                show-overflow="tooltip"
                keep-source
                :edit-config="{trigger: 'manual', mode: 'row'}"
                size="mini">
                <ux-table-column
                        v-for="item in columns"
                        v-if="!item.manyOrder"
                        :key="item.id"
                        :resizable="true"
                        :field="item.prop"
                        :title="item.label"
                        :width="item.width"
                        :fixed="item.fixed"
                        show-header-overflow='tooltip'
                        :edit-render="false"
                        align="center">
                    <template v-slot="{ row }">
                        <div v-if="item.prop == 'files'">
                            <p v-for="(it,ind) in row[item.prop]" :key="ind">{{it}}</p>
                        </div>
                        <div v-else-if="item.prop == 'is_invoiced'">{{row[item.prop]==1?'是':'否'}}</div>
                        <div v-else-if="item.prop == 'invoice_type'">{{row[item.prop]==1?'增值税专用发票':row[item.prop]==2?'增值税普通发票':''}}</div>
                        <span v-else>{{row[item.prop]}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="状态" align="center" minWidth="100" fixed="right" field="describe">
                    <template v-slot="{ row }">
                        <span v-if="row.status == 1" style="color:#EF7400">待商务审核</span>
                        <span v-if="row.status == 2" style="color:#3265f3">待财务审核</span>
                        <span v-if="row.status == 3" style="color:#d51313;">商务审核驳回</span>
                        <span v-if="row.status == 4" style="color:#00BB5D;">财务审核通过</span>
                        <span v-if="row.status == 5" style="color:#d51313;">财务审核驳回</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" align="center" minWidth="60" fixed="right" field="describe">
                    <template v-slot="{ row }">
                        <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="goDetail(row)">详情</span>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="paginationBox">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    :page-size="page_size"
                    @current-change="handleCurrentChange"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="" :visible.sync="editFlag" width="1200px" top="10vh" :close-on-click-modal='false'>
            <invoice-detail v-if="editFlag" @cancelToast='cancelToast' @emit_refresh="emit_refresh" :invoice_id='invoice_id'></invoice-detail>
        </el-dialog>
    </div>
</template>
<script>
import columnsJson from '../json/invoices_list.js'
import invoiceDetail from './invoiceDetail'
export default {
    components:{
        invoiceDetail
    },
    data(){
        return{
            pickerOptionsMonth:{
                disabledDate(time) {
                    return time.getTime() > new Date('2021-03-31 00:00:00');
                },
            },
            editFlag:false,
            status:'',
            statusList:[
                {id:'',name:'不限'},
                {id:1,name:'待商务审核'},
                {id:2,name:'待财务审核'},
                {id:3,name:'商务审核驳回'},
                {id:4,name:'财务审核通过'},
                {id:5,name:'财务审核驳回'},
            ],
            screenMonth:'',
            height:400,
            columns:[],
            page:1,
            page_size:100,
            total:0,
            loading:false,
            invoice_id:'',
            company:'',
            customer_name:'',
            change_month:'',
            approved_date:[]
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.columns = columnsJson
        
        this.init(1)
    },
    mounted(){
        this.height = document.documentElement.clientHeight - 208 > 400 ? document.documentElement.clientHeight - 208 : 400
    },
    methods:{
        emit_refresh(){//编辑成功
            this.editFlag = false;
            this.init(this.page)
        },
        cancelToast(){
            this.editFlag = false;
        },
        goDetail(data){
            this.invoice_id = data.id;
            this.editFlag=true;
        },
        handleCurrentChange(val){
            this.init(val)
        },
        init(page,exportFlag){
           this.loading = true;
           var page_size = this.page_size;
           var page = page;
           if(exportFlag){
               page = 1;
                page_size = 1000;
           }else{
                this.page = page
           }
           this.$axios.get(this.URL.BASEURL + this.URL.customerInvoicesComplement_index,{
               params:{
                   change_month:this.change_month,
                   order_month:this.screenMonth,
                   status: this.status,
                   page: page,
                   pagesize: page_size,
                   company:this.company,
                   customer_name:this.customer_name,
                   is_export:exportFlag?1:0,
                   approved_start_date: this.approved_date&&this.approved_date.length>0?this.approved_date[0]:'',
                   approved_end_date: this.approved_date&&this.approved_date.length>0?this.approved_date[1]:'',
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                     if(exportFlag){
                        this.$exportOrder({source:'all',dataList:res.rst.data,name:'2021-04之前发票列表'})
                    }else{
                        this.datas = res.rst.data
                        this.$refs.plxTable.reloadData(this.datas)
                        this.total = res.rst.pageInfo.total;
                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../statements/list.scss';
</style>
<style lang="scss">
.topSelect{
    .el-range-editor--mini .el-range-separator{
        width: 20px !important;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/invoice/listInvoice.vue